import React from 'react';
import styles from './Help.module.scss';

export default function Help({ link }) {
  return <iframe className={styles.root} src={link}></iframe>;
}
